import React from "react";
import { useTranslation } from "react-i18next";

export interface IProfileViewsChangeProps {
  profileViewsChangeRatio: number;
  pageType: "OrganizationDashboard" | "FacilityDetails";
}

export const ProfileViewsChange: React.FC<IProfileViewsChangeProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string, params = {}) =>
    _t(`facilityDetailsPage.summary.${key}`, params);

  const { profileViewsChangeRatio, pageType } = props;

  const profileViewsChangePercentage = Math.abs(
    profileViewsChangeRatio
  )?.toFixed(0);
  const sign =
    profileViewsChangeRatio > 0
      ? "positive"
      : profileViewsChangeRatio < 0
      ? "negative"
      : "zero";
  const profileViewsChangeRatioKey = `${pageType}_ratio_${sign}`;

  return (
    <div className="txt">
      <span className="points"></span>
      <div>
        {t(profileViewsChangeRatioKey, {
          profile_view_change_ratio: profileViewsChangePercentage,
        })}
      </div>
    </div>
  );
};
